import { ExponentialBackOff } from './exponentialBackoff'
import {
  IExponentialBackOffOptions,
  getOptionsSanitized,
} from './interface/types'

export async function exponentialBackOff<T>(
  request: () => Promise<T>,
  options: Partial<IExponentialBackOffOptions> = {},
): Promise<T> {
  const sanitizedOptions = getOptionsSanitized(options)
  const backOff = new ExponentialBackOff(request, sanitizedOptions)

  return await backOff.execute()
}
